<template>
  <div class="sort-list">
    <table class="table">
      <tr>
        <td style="padding-left: 32px; font-weight: bold">销售店代码/名称</td>
        <td style="font-weight: bold">使用次数</td>
      </tr>
      <tr v-for="(item, index) in rows" :key="index">
        <td>
          <span class="sort" :class="{ hot: index < 3 }">{{ index + 1 }}</span
          ><span class="text bold">【{{ item.store_code }}】</span
          ><span class="text">{{ item.store_name }}</span>
        </td>
        <td class="value">
          <span>{{ item.value }}</span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'sort-list',
  props: {
    rows: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {},
}
</script>

<style lang="less">
.sort-list {
  max-height: 500px;
  overflow: auto;
  padding-right: 10px;
  .table {
    border-collapse: collapse;
    border: none;
    width: 61.8%;
    td {
      padding: 8px 0;
    }
    span {
      vertical-align: middle;
    }
    .sort {
      width: 24px;
      height: 24px;
      line-height: 24px;
      border-radius: 50%;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      background: #f5f5f5;
      text-align: center;
      color: #8c8c8c;
      margin-right: 8px;
      &.hot {
        color: rgb(24, 144, 255);
        background-color: #e6f7ff;
      }
    }
    .text,
    .value {
      line-height: 1.5;
      color: #515a6e;
    }
    // .value {
    //   text-align: right;
    // }

    .text.bold {
      font-weight: bold;
    }
  }
}
</style>